export const FEATURES = {
  DASHBOARD: 'dashboard',
  SALES: 'sales',
  ORDERS: 'orders',
  INVENTORY: 'inventory',
  ADVERTISING: 'advertising',
  REPORTS: 'reports',
  BULK_OPS: 'bulk_operations',
  AUTOMATION: 'automation',
  AI_TOOLS: 'ai_tools',
  ADVANCED_ANALYTICS: 'advanced_analytics',
  EXPORT: 'export',
  API_TOOLS: 'api_tools',
  USER_MANAGEMENT: 'user_management',
  STORE_ADMIN: 'store_admin',
};

export const PLATFORM_ADMIN_ROLES = new Set(['super_admin', 'admin']);

/** Platform admins (Access Hub, all stores). Moderators are staff, not platform admins. */
export function isPlatformAdmin(role) {
  return PLATFORM_ADMIN_ROLES.has(role);
}

/** @deprecated Use isPlatformAdmin for hub/admin tools */
export function isAdminRole(role) {
  return isPlatformAdmin(role);
}

export function canAccessUserManagement(role) {
  return isPlatformAdmin(role) || role === 'moderator';
}

export function userHasFeature(permissions = [], feature) {
  if (!feature) return true;
  if (!permissions?.length) return false;
  if (permissions.includes('all')) return true;
  return permissions.includes(feature);
}

export const NAV_FEATURE_MAP = {
  Dashboard: FEATURES.DASHBOARD,
  Products: FEATURES.INVENTORY,
  Campaigns: FEATURES.ADVERTISING,
  'Campaign Launcher': FEATURES.ADVERTISING,
  Reports: FEATURES.REPORTS,
  'Agency tools': FEATURES.ADVERTISING,
  Categorization: FEATURES.ADVERTISING,
  'Sellerclub Automation': FEATURES.AUTOMATION,
  Automation: FEATURES.AUTOMATION,
  'Agentic AI': FEATURES.AI_TOOLS,
  'User Management': FEATURES.USER_MANAGEMENT,
  'Access Hub': FEATURES.STORE_ADMIN,
  'Store settings': FEATURES.STORE_ADMIN,
  Reporting: FEATURES.ADVANCED_ANALYTICS,
  'Marketing Stream': FEATURES.API_TOOLS,
};
